export default __webpack_public_path__ + "static/media/grafema_SET_03.b0ce0536.mp4";